// extracted by mini-css-extract-plugin
export var layoutContainer = "_7r-0";
export var layoutContainerNoRounding = "_7r-6";
export var layoutContainerOpen = "_7r-5";
export var layoutContainerResizing = "_7r-1";
export var mainContent = "_7r-2";
export var resizeDivider = "_7r-3";
export var slidePanel = "_7r-4";